import { createContext } from 'react';

const FormSelectionContext = /*#__PURE__*/createContext({
  labelIds: []
});

export { FormSelectionContext as F };
//# sourceMappingURL=form-selection.context.js.map
